import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import type { LandlordInvitation, LandlordInvitationResult } from 'types/api'

import { clientsQueryKey } from '../queries/useClients'

export function useInviteLandlords() {
  const toast = useToast()
  const queryClient = useQueryClient()
  const onError = useOnError()
  const { t } = useTranslation('users')

  async function inviteLandlords(body: LandlordInvitation) {
    const res = await apiClient.post<LandlordInvitationResult>(
      `${SNA_PREFIX}users/landlord-invitations`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: inviteLandlords,
    onSuccess: ({ invited, skipped }) => {
      if (invited.length > 0) {
        toast.success({
          message: t('landlordInvite.toast.sent', { count: invited.length })
        })
      }
      if (skipped.length > 0) {
        toast.info({
          message: t('landlordInvite.toast.skipped', { count: skipped.length })
        })
      }
      queryClient.invalidateQueries({ queryKey: clientsQueryKey })
    },
    onError
  })
}
